
<script setup>
/* eslint-disable */
import { onMounted, computed, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useLiveSportsStore } from '@/stores/live_sports';
import { useLiveSportOverview } from '@/stores/live_sport_overview';
import { useAllLiveSportOverview } from '@/stores/all_live_sport_overview';
import { useFixtureStore } from '@/stores/fixture';
import { useMarketsStore } from '@/stores/markets';
import LiveFixtureDoubleMarket from './LiveFixtureDoubleMarket.vue';
import { usePreSportsStore } from '@/stores/pre_sports';
import commonSvgs from '@/assets/svgs/commonSvgs.json'
import LiveFixtureDoubleMarketAll from './LiveFixtureDoubleMarketAll.vue';
const svg_data = ref(commonSvgs);

const router = useRouter();
const liveSportsStore = useLiveSportsStore();
const liveSportOverviewStore = useLiveSportOverview();
const allLiveSportOverviewStore = useAllLiveSportOverview();
const preSportsStore = usePreSportsStore();
const fixtureStore = useFixtureStore();
const competitions_closed = ref({});

const marketsStore = useMarketsStore();

const competitionStates = ref({}); // Track the open/closed state for each competition
const competition_closed = ref({});
// const emit = defineEmits(['update:competitions_closed']);
const props = defineProps({
	competitions_closed: {
		type: Boolean,
		required: true
	},
	competition: {
		type: Array,  // Example, adjust based on actual prop type
		required: true
	},
	primary_overview_market: {
		type: Object,
		required: true,
	},
	secondary_overview_market: {
		type: Object,
		required: true,
	},
});
const emit = defineEmits(['update:competitions_closed']);
// Watch for changes to `competitions_closed` prop
watch(() => props.competitions_closed, (newValue) => {
  // If `competitions_closed` is true, close all competitions
  alert(newValue);
  if (newValue) {
    competitionStates.value = Object.keys(allLiveSportOverviewStore.highlightFixtures).reduce((acc, key) => {
      acc[key] = false; // Close all competitions
      return acc;
    }, {});
  } else {
    // If `competitions_closed` is false, open all competitions
    competitionStates.value = Object.keys(allLiveSportOverviewStore.highlightFixtures).reduce((acc, key) => {
      acc[key] = true; // Open all competitions
      return acc;
    }, {});
  }
});

const getMarketForCompetition = (sport_id) => {
      const sport_overview_markets = marketsStore.sportOverviewMarkets(sport_id);
      if (sport_overview_markets.length > 1) {
        return { primary: sport_overview_markets[0], secondary: sport_overview_markets[1] };
      } else if (sport_overview_markets.length > 0) {
        return { primary: sport_overview_markets[0], secondary: sport_overview_markets[0] }; // Handle case for only one market
      }
      return { primary: null, secondary: null };
}

// Toggle the competition state for a specific competition
const toggleCompetitionState = (index,sportId) => {
  // Toggle the specific competition's open/close state
    competitionStates.value[index] = !competitionStates.value[index];
};

const toggleSportGroupState = (sportId) => {
    competitions_closed.value[sportId] = !competitions_closed.value[sportId];
};

const handleToggle = (competition, sportId) => {
  toggleCompetitionState(competition.id, sportId);  // Toggle individual competition state
  // toggleSportGroupState(sportId);           // Toggle sport group state
};

// const allLiveSportOverviewStore = ref({
//   highlightFixtures: [
//     { sport_name: 'Football', competition_name: 'Premier League', region_name: 'England', region_icon_url: '/england.png' },
//     { sport_name: 'Football', competition_name: 'La Liga', region_name: 'Spain', region_icon_url: '/spain.png' },
//     { sport_name: 'Basketball', competition_name: 'NBA', region_name: 'USA', region_icon_url: '/usa.png' },
//     { sport_name: 'Basketball', competition_name: 'EuroLeague', region_name: 'Europe', region_icon_url: '/europe.png' }
//   ]
// });

// Group by sport_name
const groupBySport = (fixtures) => {
  const groupedBySport = {};

  Object.values(fixtures).forEach((competitions) => {
    competitions.forEach((competition) => {
      const sportName = competition.sport_id;

      if (!groupedBySport[sportName]) {
        groupedBySport[sportName] = [];
      }

      const regionIcon = competition.region_icon_url ?? '/images/default-icon.png';
      competition.region_icon_url = regionIcon;
      groupedBySport[sportName].push(competition);
    });
  });

  // order by key
let esport_ids = [53, 54, 55, 56, 16, 21, 23, 27, 29];

  const sortedGroupedBySport = {};

  // Sort the sport_ids according to the customer's preference
  Object.keys(groupedBySport).sort((a, b) => {
    return esport_ids.indexOf(a) - esport_ids.indexOf(b);
  }).forEach((key) => {
    sortedGroupedBySport[key] = groupedBySport[key];
  });

  return sortedGroupedBySport;
};

</script>
<template>
	<div id="live" class="tab-content highlight-live">
     <!-- Group by sport_name (if necessary) -->
	  <!-- Group by sport_name (if necessary) -->
    <!-- {{ JSON.stringify(groupBySport(allLiveSportOverviewStore.highlightFixtures)) }} -->
	  <div class="live-set-main" v-for="(competitions, sportName) in groupBySport(allLiveSportOverviewStore.highlightFixtures)" :key="sportName">
      <div class="dashboard-info-label">
        <div class="sport-title">
          <img :src="preSportsStore.preSportWhiteIcon(competitions[0].sport_id)" alt="icon" width="50px">
          <h6>{{ competitions[0].sport_name }}</h6>
        </div>

        <span class="toggle-markets">
            <div @click="toggleSportGroupState(competitions[0].sport_id)" class="markets-toggle-fill">
              <svg v-if="!competitions_closed[competitions[0].sport_id]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="markets-toggle-svg">
                <use xlink:href="/assets/icons/markets_close.svg#markets_close"></use>
              </svg>
              <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="markets-toggle-svg">
                <use xlink:href="/assets/icons/markets_open.svg#markets_open"></use>
              </svg>
              </div>
          </span>

      </div>

      <!-- Loop through each competition -->
      <div v-for="(competition, index) in competitions" :key="competition.id" class="live-info-outer-main">
        <div class="live-info-outer">
          <div class="live-info-inner">
            <div class="live-info-team">
              <div class="live-match">
                <div class="team-flag">
                  <img :src="'/assets' + competition.region_icon_url" alt="" />
                </div>
                <div class="live-match-name">
                  <h3>{{ competition.region_name }} - {{ competition.competition_name }}</h3>
                </div>
              </div>
            </div>

            <span class="bet-column-empty">
              <div @click="handleToggle(competition, competitions[0].sport_id)" class="market-arrow">
                <a class="market-arrow-icon" :class="competitionStates[competition.id] ? 'market-arrow-icon-closed' : ''"></a>
              </div>
            </span>
          </div>

          <!-- Show competition details when expanded -->
          <template v-if="(!competitionStates[competition.id] && !competitions_closed[competitions[0].sport_id]) || (competitionStates[competition.id] == true && competitions_closed[competitions[0].sport_id] == true) ">
            <LiveFixtureDoubleMarketAll
              :key="0"
              :primary_overview_market="getMarketForCompetition(competition.sport_id).primary"
              :secondary_overview_market="getMarketForCompetition(competition.sport_id).secondary"
              :fixture="competition"
            />
          </template>
        </div>
      </div>
    </div>



		<!-- <div class="live-info-outer-main" v-for="(competition, index) in allLiveSportOverviewStore.highlightFixtures" :key="index">

			<div class="live-info-outer">
				<div class="live-info-inner">
					<div class="live-info-team">
						<div class="live-match">
							<div class="team-flag">
								<img :src="'/assets' + competition[0].region_icon_url" alt="">
							</div>
							<div class="live-match-name">
								<h3>{{ competition[0].region_name }} - {{ competition[0].competition_name }}</h3>
							</div>
						</div>
					</div>


					<span class="bet-column-empty">
						<div @click="toggleCompetitionState(index)" class="market-arrow">
						<a class="market-arrow-icon" :class="competitionStates[index] ? 'market-arrow-icon-closed' : ''"></a>
					</div>

				</span>
				</div>
				<template v-if="!competitionStates[index]">
					<LiveFixtureDoubleMarketAll v-for="(fixture, index) in competition"
						:key="index"
						:primary_overview_market="getMarketForCompetition(competition[0].sport_id).primary"
						:secondary_overview_market="getMarketForCompetition(competition[0].sport_id).secondary"
						:fixture="fixture"
					/>
				</template>
			</div>
		</div> -->
	</div>
</template>

<style scoped>
html[dir="rtl"] .live-bet-dashboard .live-tab-info .live-info-outer .live-info-inner .live-info-team .live-match .live-match-name .live-badge {
	margin-right: 10px;
}

</style>